import templateUrl from './edit-product-order.component.html';

export const EditProductOrderComponent = {
    controller: class EditProductOrderComponent {
        onChangeProduct(productOrder) {
            productOrder.ProductID = productOrder.Product ? productOrder.Product.ProductID : null;
        }

        onChangeProductLine(productOrder) {
            productOrder.ProductLineID = productOrder.ProductLine ? productOrder.ProductLine.ProductLineID : null;
        }

        onChangeProductOrderStatus(productOrder) {
            productOrder.ProductOrderStatusID = productOrder.Status ? productOrder.Status.ProductOrderStatusID : null;
        }
    },
    require: {
        editForm: "^^?form"
    },
    controllerAs: "vm",
    bindings: {
        productOrder: "<",
        products: "<",
        productLines: "<",
        productOrderStatuses: "<"
    },
    templateUrl
};
